import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const goodFit = [
  { icon: 'ri-store-2-line', text: 'Entre 1 e 20 lojas ou unidades' },
  { icon: 'ri-price-tag-3-line', text: 'Catálogo aproximado de 100 a 10.000 produtos ativos' },
  { icon: 'ri-calendar-check-line', text: 'Pelo menos 12 meses de histórico de vendas' },
  { icon: 'ri-refresh-line', text: 'Compras recorrentes e capital relevante em estoque' },
];

const notYet = [
  { icon: 'ri-time-line', text: 'Menos de 12 meses de histórico de vendas' },
  { icon: 'ri-price-tag-3-line', text: 'Catálogo muito pequeno de produtos' },
  { icon: 'ri-file-forbid-line', text: 'Não há registro digital de vendas' },
  { icon: 'ri-shuffle-line', text: 'A operação não faz compras recorrentes' },
];

export default function FitSection() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section id="para-quem-e" className="py-20 md:py-28 bg-zinc-50">
      <div className="max-w-7xl mx-auto px-6" ref={ref}>
        <div className="text-center mb-14">
          <span className="inline-block font-sora font-semibold text-emerald-600 text-sm uppercase tracking-widest mb-3">
            Para quem é
          </span>
          <h2 className="font-sora font-bold text-3xl md:text-4xl text-zinc-900 mb-4">
            Sejamos honestos sobre o fit
          </h2>
          <p className="font-inter text-zinc-500 max-w-xl mx-auto text-base">
            Um diagnóstico de demanda só faz sentido quando existe histórico e volume
            suficientes para trabalhar.
          </p>
          <div className="w-12 h-1 bg-emerald-500 rounded-full mx-auto mt-5" />
        </div>

        <div
          className={`grid grid-cols-1 lg:grid-cols-2 gap-6 transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="bg-white rounded-2xl border border-emerald-200 p-6 md:p-8">
            <div className="flex items-center gap-4 mb-6">
              <div
                className="w-12 h-12 flex items-center justify-center rounded-xl bg-emerald-500/10 border border-emerald-500/20"
                aria-hidden="true"
              >
                <i className="ri-check-double-line text-emerald-600 text-xl" />
              </div>
              <h3 className="font-sora font-bold text-lg text-zinc-900">
                Faz sentido para você se
              </h3>
            </div>
            <ul className="space-y-4">
              {goodFit.map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  <span
                    className="w-7 h-7 shrink-0 flex items-center justify-center rounded-lg bg-emerald-500/10"
                    aria-hidden="true"
                  >
                    <i className={`${item.icon} text-emerald-600 text-sm`} />
                  </span>
                  <span className="font-inter text-zinc-700 text-sm leading-relaxed">
                    {item.text}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-white rounded-2xl border border-zinc-200 p-6 md:p-8">
            <div className="flex items-center gap-4 mb-6">
              <div
                className="w-12 h-12 flex items-center justify-center rounded-xl bg-zinc-100 border border-zinc-200"
                aria-hidden="true"
              >
                <i className="ri-time-line text-zinc-500 text-xl" />
              </div>
              <h3 className="font-sora font-bold text-lg text-zinc-900">
                Ainda não é o momento se
              </h3>
            </div>
            <ul className="space-y-4">
              {notYet.map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  <span
                    className="w-7 h-7 shrink-0 flex items-center justify-center rounded-lg bg-zinc-100"
                    aria-hidden="true"
                  >
                    <i className={`${item.icon} text-zinc-500 text-sm`} />
                  </span>
                  <span className="font-inter text-zinc-700 text-sm leading-relaxed">
                    {item.text}
                  </span>
                </li>
              ))}
            </ul>
            <p className="font-inter text-zinc-400 text-xs leading-relaxed mt-6">
              Se esse é o seu caso, guarde o histórico e volte quando houver base
              suficiente. Um diagnóstico feito cedo demais não entrega valor real.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
